import { useTranslation } from 'react-i18next';
// eslint-disable-next-line max-len
import { type FinderApplicationPrivateModuleSpecsFragment } from '../../../../api/fragments/FinderApplicationPrivateModuleSpecs';
// eslint-disable-next-line max-len
import { type FinderApplicationPublicModuleSpecsFragment } from '../../../../api/fragments/FinderApplicationPublicModuleSpecs';
import ApplicationModuleFinanceProductAssignments from '../shared/ApplicationModuleFinanceProductAssignments';

export type UpdateFinanceProductAssignmentsValue = {
    dealerFinanceProducts: Record<string, string[]>;
};

export type FinanceProductAssignmentsProps = {
    module: FinderApplicationPublicModuleSpecsFragment | FinderApplicationPrivateModuleSpecsFragment;
};

const FinanceProductAssignments = ({ module }: FinanceProductAssignmentsProps) => {
    const { t } = useTranslation(['eventApplicationModuleDetails']);

    return (
        <ApplicationModuleFinanceProductAssignments
            module={module}
            noItemText={t('eventApplicationModuleDetails:tabs.financeProducts.noData')}
        />
    );
};

export default FinanceProductAssignments;
